import React from "react";

const BASE_PATH = "images/";

export const SiLogo: React.FC<{ type?: string; size?: string, organizationLogoUrl?: string }> = ({
  type = "",
  size = "",
  organizationLogoUrl = ""
}) => {
  let filename = "logo";

  if (type === "colored") filename += "-colored";
  if (size === "small") filename += "-small";

  return (
    <si-logo>
      {
        organizationLogoUrl
        ? <img src={`${organizationLogoUrl}`} className="logo" alt="" />
        : <img src={`${BASE_PATH}${filename}.png`} className="logo" alt="" />
      }
    </si-logo>
  );
};
